
import { computed, defineComponent, reactive, ref } from 'vue'
import NavUserInfo from './nav-userInfo.vue'
import ZpBreadcrumb, { IBreadcrumb } from '@/Base-UI/breadcrumb/index'
import { pathMapBreadcrumb } from '@/utils/map-menus'
import { useRoute } from 'vue-router'
import { useStore } from '@/store/index'
export default defineComponent({
  emits: ['iconChange'],
  name: 'nav-header',
  setup(props, { emit }) {
    let isIcon = ref(false)
    const route = useRoute()
    const store = useStore()
    /* 点击发送给main.vue事件 */
    const iconClick = () => {
      isIcon.value = !isIcon.value
      emit('iconChange', isIcon.value)
    }
    const breadcrumb = computed(() => {
      /* 面包屑数据 */
      const userMenus = computed(() => store.state.login.userMenus)
      return pathMapBreadcrumb(userMenus.value, route.path)
    })
    return {
      isIcon,
      breadcrumb,
      iconClick
    }
  },
  components: {
    NavUserInfo,
    ZpBreadcrumb
  }
})
